export default function getStopTestTutomat(state) {
    return state.tutomat;
}